import { FormikProps } from 'formik'
import { Product } from 'modules/domain/collection/types'
import { Deal } from 'modules/domain/deal/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SharedModalInputs } from 'views/components/SharedModal'
import { SharedModalSecondContent, SharedModalSubTitle } from 'views/components/SharedModal/styled'
import { DealContractForm } from '../../../types'
import { ControlsBlock } from './ControlsBlock'
import { InfoBlock } from './InfoBlock'
import { ProductParams } from './ProductParams/ProductParams'
type Props = {
  deal: Deal
  formik: FormikProps<DealContractForm>
  product: Product | undefined
  editMode?: boolean
}
export const CommonFields: FC<Props> = ({ deal, formik, product, editMode = false }) => {
  const { t } = useTranslation('deal')
  let companyId
  if (deal.sale_bid.company.is_in_group) {
    companyId = deal.sale_bid.company.parent?.id || deal.sale_bid.company.id
  }
  return (
    <>
      <SharedModalInputs>
        <InfoBlock deal={deal} />
        <ControlsBlock formik={formik} companyId={parseInt(companyId)} editMode={editMode} />
      </SharedModalInputs>

      <SharedModalSecondContent>
        <SharedModalSubTitle>{t('requestDocsModal.product_params')}</SharedModalSubTitle>
        {product && <ProductParams formik={formik} product={product} />}
      </SharedModalSecondContent>
    </>
  )
}
